import { Component, ElementRef, Input, OnInit, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { PlatformService } from 'src/app/platform.service';
import { DataService } from 'src/app/services/data.service';
import { LoaderService } from 'src/app/services/loader.service';
import { PermitsService } from 'src/app/services/permits.service';
import { ToastService } from 'src/app/services/toast.service';
import {PaymentsPage} from '../../modals/payments/payments.page'
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { EnterlotpasswordPage } from 'src/app/pages/enterlotpassword/enterlotpassword.page';
@Component({
  selector: 'app-standard-permit',
  templateUrl: './standard-permit.page.html',
  styleUrls: ['./standard-permit.page.scss'],
})
export class StandardPermitPage{
  @ViewChildren("divs") private divs: QueryList<ElementRef>;
  loaded = false;
  width=window.innerWidth;
  height=window.innerHeight;
  @Input() lotNameId: any;
  permit: any = {};
  @Input() isModal:any;
  errors = {
    LOT_NOT_AVAILABLE: 'lot-not-available',
    SOLD_OUT: 'sold-out',
    LOT_NOT_VISIBLE: 'lot-not-visible',
    ALREADY_HAS_PERMIT: 'already-has-permit',
    LOT_TYPE_NOT_AVAILABLE: 'temp-lot-type-not-available',
    INVALID_DATE_SELECTION: 'temp-invalid-date-selection',
    ALREADY_ON_WAITING_LIST: 'Already on wait list.',
  };
  constructor(
    private renderer: Renderer2,
    private errorHandlerSRV:ErrorHandlerService,
    public platformSRV:PlatformService,
    private toasterSRV: ToastService,
    private modalCtrl: ModalController,
    private loaderSRV: LoaderService,
    public permitsSRV: PermitsService,
    private route: ActivatedRoute,
    public dataService: DataService,
    private router: Router,
    public translateService: TranslateService,
  ) {}
  showMore(e:Event){
    
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[1], "display", 'none');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[2], "display", 'block');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "overflow", 'visible');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "height", 'auto');
    
  }
  showLess(e:Event){
    
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[1], "display", 'block');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[2], "display", 'none');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "overflow", 'hidden');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "height", '60px');
    
  }
  closeModal() {
    if(this.isModal){
      this.modalCtrl.dismiss();
    } else {
      this.router.navigateByUrl('permits')
    }
  }
  async ionViewWillEnter() {
 
    this.permitsSRV.permit.next({});
    this.getPermit();
  }

  private getPermit() {
    
    if(!this.isModal){
      this.lotNameId = this.route.snapshot.paramMap.get('id');

    }
    let url = `permits/standard/reservation/${this.lotNameId}`;
    this.dataService.getData(url).subscribe({
      next: async (res:any) => {
        if (res?.error_code==2028) {
          const  value  = await this.dataService.getStoredData({ key: `passwordEntered`})
          if (!value || value?.lotNameID != this.lotNameId || value?.passwordEntered != true){
            const modal = await this.modalCtrl.create({
              component: EnterlotpasswordPage, // Component for entering the password
              componentProps: {
                LotNameID:this.lotNameId,
                permitType:"standard"
              } ,
            });
        
            await modal.present();
            const { data } = await modal.onDidDismiss();
            if (data && data.passwordEntered) {
              this.ionViewWillEnter()
            } else {
              this.closeModal()
            }
          }
        } else {
          var taxes=[]
          for (var i = 0; i < Object.entries(res['totals']['taxes']).length; i++)
        {
          taxes.push( Object.entries(res['totals']['taxes'])[i][1])
          
        }
        res['totals']['taxes'] = taxes
        
          this.permitsSRV.permit.next(res);
          this.loaded = true;
          setTimeout(() => {
            this.divs.forEach(data=>{
              if(data.nativeElement.children[0].clientHeight<70){
                //hide show more button
                this.renderer.setStyle(data.nativeElement.children[1], "display", 'none');
                //hide show less button
                this.renderer.setStyle(data.nativeElement.children[2], "display", 'none');
              } else {
                //hide show less button
                this.renderer.setStyle(data.nativeElement.children[2], "display", 'none');
                this.renderer.setStyle(data.nativeElement.children[0], "height", '70px');
                this.renderer.setStyle(data.nativeElement.children[0], "overflow", 'hidden');
              }
              
            })
           }, 10);
        }
        
       
      },
      error: async (error) => {
        
        if(error?.permit?.error=="already-has-permit"){
          this.permitsSRV.permit.next(error)


         } else {
          this.errorHandlerSRV.displayErrorMessage(error,true)
         }
        
        this.loaded = true;
       
      }
    });
  }

  onReservePermit() {
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.permits.reserving_permit') || 'Reserving permit...');
    const url = `account/endpoint/reserve_standard/${this.lotNameId}`;
    this.dataService.postData(url, {}).subscribe({
      next: async (v) => {
        if(v['status']=="success"){
        this.loaderSRV.dismissLoader();
        this.modalCtrl.dismiss();
        this.toasterSRV.presentToast(this.translateService.instant('keys.data.permits.permit_reserved') || 'Permit reserved successfully');
        const desktopModal = await this.modalCtrl.create({
          component: PaymentsPage,
          breakpoints: [0.5, 0.8,1],
         
          cssClass: 'modal-desktop-long',
         
        });
        const mobileModal = await this.modalCtrl.create({
          component: PaymentsPage,
          breakpoints: [0.5, 0.8,1],
          initialBreakpoint: 1,
          cssClass:"modal-mobile-normal",
         
        })
        const tabletModal = await this.modalCtrl.create({
          component: PaymentsPage,
          breakpoints: [0.5, 0.8,1],
          initialBreakpoint: 1, 
          cssClass:"modal-tablet-normal",
         
        })
        var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
        modal.present()
        } else {
          this.loaderSRV.dismissLoader();
          this.errorHandlerSRV.displayErrorMessage(v,true)

        }
      },
      error: (err) => {
        this.errorHandlerSRV.displayErrorMessage(err,true)
        
      },
    });
  }
}
